import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'reboron/DropModal'

import QuestIcon from './QuestIcon'

export default class ModalComponent extends Component {
  constructor() {
    super()
    this.onHideBound = this.onHide.bind(this)
  }

  render() {
    const { quest } = this.props
    const modalStyle = {
      width: '402px',
      background: '#fff',
      borderRadius: '5px'
    }
    const contentStyle = {
      outline: 'none'
    }

    return (
      <Modal
        ref="modal"
        className={this.props.klass}
        modalStyle={modalStyle}
        contentStyle={contentStyle}
        onHide={this.onHideBound}
      >
        <div id={this.props.modalId}>
          <div className={this.props.headingKlass}>
            {quest && this.props.questLogo && (
              <QuestIcon
                heightWidth={54}
                icon_image_url={quest.icon_image_url}
              />
            )}
            {!this.props.questLogo && (
              <div className={this.props.logoKlass}></div>
            )}
            <div className="heading-text h3">{this.props.headingText}</div>
          </div>
          <div className="modal-body">
            {this.props.setRawHtmlInBody ? (
              <div
                className="modal-body-text"
                dangerouslySetInnerHTML={{ __html: this.props.bodyText }}
              />
            ) : (
              <div className="modal-body-text">{this.props.bodyText}</div>
            )}
            <div className="actions">
              <div
                className="button modal-cancel"
                onClick={this.props.secondaryButtonAction}
              >
                {this.props.secondaryButtonText}
              </div>
              <div
                className={this.getPrimaryButtonClass()}
                onClick={this.props.primaryButtonAction}
              >
                {this.props.primaryButtonText}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  getPrimaryButtonClass() {
    var retVal = 'button modal-confirm'
    if (this.props.primaryButtonDestructiveClass) {
      retVal += ' btn-destructive-dark'
    }
    return retVal
  }

  onHide(e) {
    if (
      this.props.handleNonButtonCancelAction &&
      (e === 'keyboard' || e === 'backdrop')
    ) {
      this.props.handleNonButtonCancelAction()
    }
  }
}

ModalComponent.propTypes = {
  quest: PropTypes.object,
  klass: PropTypes.string,
  modalId: PropTypes.string,
  headingKlass: PropTypes.string,
  logoKlass: PropTypes.string,
  headingText: PropTypes.string,
  bodyText: PropTypes.any,
  secondaryButtonAction: PropTypes.func,
  secondaryButtonText: PropTypes.string,
  primaryButtonAction: PropTypes.func,
  primaryButtonText: PropTypes.string,
  questLogo: PropTypes.bool,
  primaryButtonDestructiveClass: PropTypes.bool,
  setRawHtmlInBody: PropTypes.bool,
  handleNonButtonCancelAction: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/mini/ModalComponent.js